import {gql} from '@apollo/client';

export const GET_NOTIFICATION_BUCKETS = gql`
  query GetNotificationBuckets($input: NotificationBucketFilterInput) {
    getNotificationBuckets(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithNotificationBuckets {
        message
        data {
          id
          key
          name
          description
          cooldownHours
          dropPolicy
          dropAfterShiftHours
          requiresApproval
          verifiers {
            userIds
            userRoles
            users {
              id
              firstName
              lastName
              email
            }
          }
          defaultApprovers
          active
          createdAt
          updatedAt
        }
        pagination {
          page
          limit
          pages
          total
        }
      }
    }
  }
`;

export const GET_NOTIFICATION_BUCKET_BY_KEY = gql`
  query GetNotificationBucketByKey($key: String!) {
    getNotificationBucketByKey(key: $key) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithNotificationBucket {
        message
        data {
          id
          key
          name
          description
          cooldownHours
          dropPolicy
          dropAfterShiftHours
          requiresApproval
          verifiers {
            userIds
            userRoles
            users {
              id
              firstName
              lastName
              email
            }
          }
          defaultApprovers
          active
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export const GET_NOTIFICATION_WORKFLOWS = gql`
  query GetNotificationWorkflows($input: NotificationWorkflowFilterInput) {
    getNotificationWorkflows(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithNotificationWorkflows {
        message
        data {
          id
          workflowKey
          name
          description
          bucket
          priority
          active
          createdAt
          updatedAt
        }
        pagination {
          page
          limit
          pages
          total
        }
      }
    }
  }
`;

export const GET_ORCHESTRATOR_NOTIFICATIONS = gql`
  query GetOrchestratorNotifications(
    $input: ScheduledNotificationFilterInput!
  ) {
    getScheduledNotifications(input: $input) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithNotifications {
        message
        pagination {
          page
          limit
          pages
          total
        }
        data {
          id
          title
          status
          draft
          isActive
          bucket
          workflowKey
          schedule {
            date
          }
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export const GET_NOTIFICATION_WORKFLOW_BY_KEY = gql`
  query GetNotificationWorkflowByKey($workflowKey: String!) {
    getNotificationWorkflowByKey(workflowKey: $workflowKey) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithNotificationWorkflow {
        message
        data {
          id
          workflowKey
          name
          description
          bucket
          priority
          active
          createdAt
          updatedAt
        }
      }
    }
  }
`;
